import { Link } from 'react-router-dom';
import './Card.scss';

export const Card = ({ title, text, path }) => {
  return (
    <Link className='card-link d-block h-100' to={path}>
      <div className='card border-0 p-3 h-100'>
        <h5 className='card-title'>{title}</h5>
        <p className='card-text'>{text}</p>
      </div>
    </Link>
  );
};
